// "CODE - Name" of a property, for report headers and prints — read once per id,
// so a report opened on the default property names it without the filter panel
// ever loading its options.

import { useEffect, useState } from 'react';
import { propertyService } from 'api/services/propertyService';

export const usePropertyLabel = (propertyId: string): string => {
  const [label, setLabel] = useState('');

  useEffect(() => {
    if (!propertyId) { setLabel(''); return; }
    let cancelled = false;
    propertyService.getById(propertyId)
      .then((res) => {
        const p: any = res?.data;
        if (!cancelled && p) setLabel(`${p.propertyCode} - ${p.propertyName}`);
      })
      .catch(() => { if (!cancelled) setLabel(''); });
    return () => { cancelled = true; };
  }, [propertyId]);

  return label;
};
